import { Tooltip } from "@mui/material";
import { Icon } from "@vds/icons";
import { Body } from "@vds/typography";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../../global/utility/permissionUtils";
import { showNotificationBanner } from "../../../store/actions";
import BaselineCount from "../BaselineCount";
import { useStatisticContext } from "../contexts/StatisticContext";

const AdvancedOptions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    filterlist,
    appName,
    chart,
    selectedSite,
    siteNameForViewTag,
    encryptPayload,
    siteName,
    siteList,
    setShowHideFilter,
    showHideFilter,
    selectedFloors,
    selectedAreas,
    selectedSubAreas,
    matchingLocationAreas,
    matchingLocationSubAreas,
    matchingLocationFloors,
    setBaselineDataSourcesToggleDropdown,
    baselineDataSourcesToggleDropdown,
    baselineVisibility,
    filteredTagsListArray,
    tagIdList,
    tagListItem,
    sitesTagList,
    roisListWithApps,
    appNameForViewTag,
    reloadWidgetsAfterForceReset
  } = useStatisticContext();

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const handleView_Data_Source = (e) => {
    if (!hasPermission("Apps", "Edit")) {
      showPermissionsBanner();
    } else {
      if (filterlist) {
        navigate("/statDataSource", {
          state: {
            appName: appName,
            chart: chart,
            appNameId: appName,
            siteName: selectedSite.length > 0 ? filterlist.Site : siteList[0].name,
            baseLineDateTime: encryptPayload.startDate,
            site: selectedSite.length > 0 ? selectedSite : [siteList[0]],
            floor: selectedFloors,
            area: selectedAreas,
            subarea: selectedSubAreas,
            allFloors: matchingLocationFloors,
            allAreas: matchingLocationAreas,
            allSubAreas: matchingLocationSubAreas,
            filterlist: filterlist
          }
        });
      }
    }
  };

  return (
    <div className="filterBarMainSetting">
      <div style={{ display: "flex", width: "100%" }}>
        <div className="moreContainer" onClick={() => setBaselineDataSourcesToggleDropdown(!baselineDataSourcesToggleDropdown)}>
          <div className="advancedSettingsWrapper">
            <Tooltip
              placement="bottom"
              title={
                <div
                  style={{
                    width: "auto",
                    padding: "5px",
                    color: "black",
                    fontSize: "12px",
                    backgroundColor: "white"
                  }}
                >
                  <Body viewport="desktop" size="small" bold={true}>
                    {" "}
                  </Body>
                  <Body size="small" viewport="desktop">
                    Advanced options
                  </Body>
                </div>
              }
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    border: "1px solid black",
                    "& .MuiTooltip-arrow": {
                      backgroundColor: "white"
                    }
                  }
                }
              }}
            >
              <sup style={{ top: "0px" }}>
                {" "}
                <Icon name="advanced-settings" color="#000000" size="large" />{" "}
              </sup>
            </Tooltip>
          </div>{" "}
        </div>
      </div>
      {baselineDataSourcesToggleDropdown && (
        <div className="toggleDropdownWrapper">
          {baselineVisibility.length > 0 && (
            <BaselineCount
              siteNameForViewTag={siteNameForViewTag}
              appName={appName}
              tagIdList={tagIdList}
              filteredTagsListArray={filteredTagsListArray}
              tagListItem={tagListItem}
              sitesTagList={sitesTagList}
              encryptPayload={encryptPayload}
              roisListWithApps={roisListWithApps}
              cvappName={appNameForViewTag}
              postForceRestAction={reloadWidgetsAfterForceReset}
              setShowHideFilter={setShowHideFilter}
              showHideFilter={showHideFilter}
              setBaselineDataSourcesToggleDropdown={setBaselineDataSourcesToggleDropdown}
              statBaseSettingsTag={
                selectedSubAreas.length > 0
                  ? selectedSubAreas
                  : selectedAreas.length > 0
                    ? selectedAreas
                    : selectedFloors.length > 0
                      ? selectedFloors
                      : selectedSite.length > 0
                        ? selectedSite
                        : [siteList[0]]
              }
            ></BaselineCount>
          )}

          <div className="">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingLeft: "10px"
              }}
            >
              {" "}
              <b>Data sources </b>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <ul>
                <li onClick={handleView_Data_Source}>
                  <span> View contributing data sources </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedOptions;
